import { CssBaseline } from "@mui/material";
import { Route } from "react-router-dom";
import type { UserRole } from "../auth/auth";
import PageTitle from "../misc/PageTitle";
import { PackagesListing } from "./listing/PackagesListing";
import PublicPackagesRegionsPage from "./regions/PublicPackagesRegionsPage";
import { PublicPackagePage } from "./single-package/";

export function PackagesRoutes2({ role }: { role: UserRole | null }) {
  return (
    <Route path="public/packages">
      <Route
        index
        element={
          <>
            <PageTitle title="kategorie pakietów" />
            <PublicPackagesRegionsPage />
          </>
        }
      />
      <Route
        path="filter"
        element={
          <>
            <PageTitle title="pakiety" />
            <PackagesListing />
          </>
        }
      />

      <Route
        path=":packageId"
        element={
          <>
            <PageTitle title="szczegóły pakietu" />
            <CssBaseline />
            <PublicPackagePage role={role} />
          </>
        }
      />
    </Route>
  );
}
